import gql from 'graphql-tag'

export const GET_ALL_PRODUCTS = gql`
    query {
        Products: Products(order_by: {sequence: asc_nulls_last}){
            id
            name
            image
            colorCode
            displayName
            bunchKg
            noOfPieceInBox
            weight
            sequence
            baseName
            packageType
            containerType
        }
    }`

export const GET_ALL_PRODUCTS_WITH_PRICES = gql`
    query {
        Products(order_by: {sequence: asc_nulls_last}){
            id
            displayName
            bunchKg
            image
            colorCode
            weight
            packageType
            ProductPrices{
                id
                price
                unitId
                priceListId
            }
        }
    }`

export const GET_ALL_PRICES_AND_PRODUCTS = gql`
    query($priceListId:uuid!,$unitId:uuid!){
        Prices(where:{priceListId:{_eq:$priceListId},unitId:{_eq:$unitId}}){
            id
            price
            Product{
                id
                displayName
                bunchKg
                image
                colorCode
                weight
                packageType
            }
        }
    }`

export const GET_PRODUCTS_WITH_PRICES_AND_STOCK = gql`
query getProductsWithPricesAndStock($orgId:uuid!, $priceListId:uuid!){
   Products(order_by: {sequence: asc_nulls_last}){
    id
    image
    weight
    displayName
    containerType
    packageType
    noOfPieceInBox
    prices: ProductPrices(where:{priceListId:{_eq:$priceListId}}) {id unitId price}
    stocks: OrganizationStock(where:{organizationId:{_eq:$orgId}}) { id unitId quantity reservedQuantity}
   }
}`
